var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.285,
    height: 23.109,
    viewBox: "0 0 16.285 23.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8326",
    "data-name": "Rectangle 8326",
    width: 16.285,
    height: 23.109,
    fill: "#fc0b06",
    stroke: "#ff0500",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30525",
    "data-name": "Group 30525",
    transform: "translate(-43.107 -760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(43.107 760)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 8.261,
    transform: "translate(4.078 8.697)",
    fill: "none",
    stroke: "#fc0b06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 5.582,
    transform: "translate(4.078 11.44)",
    fill: "none",
    stroke: "#fc0b06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 3.126,
    transform: "translate(4.078 14.184)",
    fill: "none",
    stroke: "#fc0b06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180-2",
    "data-name": "Group 180",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11669",
    "data-name": "Path 11669",
    d: "M2.835,7.434H7.11v-4.6",
    transform: "translate(-2.155 -2.155)",
    fill: "none",
    stroke: "#fc0b06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11670",
    "data-name": "Path 11670",
    d: "M14.844,24.585H5.752a2.918,2.918,0,0,1-2.917-2.917V5.752A2.917,2.917,0,0,1,5.752,2.835h9.092a2.917,2.917,0,0,1,2.917,2.917V21.667a2.917,2.917,0,0,1-2.917,2.917Z",
    transform: "translate(-2.155 -2.155)",
    fill: "none",
    stroke: "#fc0b06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11671",
    "data-name": "Path 11671",
    d: "M2.835,74.515v1.646a2.917,2.917,0,0,0,2.917,2.917h9.092a2.917,2.917,0,0,0,2.917-2.917V74.515Z",
    transform: "translate(-2.155 -56.649)",
    fill: "#fc0b06",
    stroke: "#fc0b06",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11672",
    "data-name": "Path 11672",
    d: "M2.835,74.515v1.646a2.917,2.917,0,0,0,2.917,2.917h9.092a2.917,2.917,0,0,0,2.917-2.917V74.515Z",
    transform: "translate(-2.155 -56.649)",
    fill: "none",
    stroke: "#fc0b06",
    strokeLinecap: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    transform: "translate(48 781)",
    fill: "#fff",
    fontSize: 4,
    fontFamily: "RocGrotesk-Regular, Roc Grotesk",
    letterSpacing: "0.025em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedPdf);
export default __webpack_public_path__ + "static/media/redPDF.a689c3980a8444dbd32d62e9c328176e.svg";
export { ForwardRef as ReactComponent };